<template>
  <div id="about" class="groupage-cargo-props flex mt-70">
    <div class="groupage-cargo-props-wrapper mr-20">
      <h2 class="mb-30">{{ title }}</h2>
      <ul class="public-list public-list-square">
        <li v-for="text in data.list.split(';')">
          <span v-html="text" />
        </li>
      </ul>
    </div>
    <public-card-info
      :title="data.cardTitle"
      :text="data.cardText"
      img-url="/images/pages/groupage-cargo/cargo.png"
    />
  </div>
</template>

<script setup lang="ts">
import PublicCardInfo from '~/components/public/public-card-info.vue'
import {storeToRefs} from 'pinia';
import {useCityStore} from '~/stores/city';
import {getPageContent, replaceContentText} from '~/api/content';

const { currentCity } = storeToRefs(useCityStore())

const data = (await getPageContent('/groupage-cargo')).blocks?.about

const title = computed(() => {
  return replaceContentText(data.title, { city: currentCity.value })
})
</script>

<style lang="scss" scoped>
.groupage-cargo-props {
  @media only screen and (max-width: $pub-sm) {
    margin-top: 50px;
  }

  @media only screen and (max-width: $pub-xs) {
    flex-direction: column;
  }

  h2 {
    text-align: left;
  }

  &-wrapper {
    @media only screen and (max-width: $pub-xs) {
      margin-right: 0;
    }
  }

  .public-card-info {
    @media only screen and (max-width: $pub-xs) {
      margin: 40px auto 60px;
    }
  }

  ul {
    a {
      display: block;
    }
  }
}
</style>
